// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-BXnrm7{background:#0f1117;border-radius:12px;width:100%;height:100%;min-height:480px;position:relative;overflow:hidden}.iframe-mCq0v8{border:0;width:100%;height:100%}.loading-mask-xOlUqh{background:rgba(15,17,23,.6);justify-content:center;align-items:center;display:flex;position:absolute;top:0;bottom:0;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root-BXnrm7`,
	"iframe": `iframe-mCq0v8`,
	"loading-mask": `loading-mask-xOlUqh`,
	"loadingMask": `loading-mask-xOlUqh`
};
export default ___CSS_LOADER_EXPORT___;
